import apiClientCoinGecko from '../Api/ApiClientCoinGecko';
import apiNameCoinGecko from '../Api/ApiNameCoinGecko.json';



export const callAPiCoinMarket = (param={}) => {
    return apiClientCoinGecko.get(apiNameCoinGecko.coin_market,{
        params:{
            ...param,
            "price_change_percentage":"1h,24h,7d",
            "sparkline":true
        }
    })
} 


export const callApiCoinMarketV2 = (param={})=>{
    return apiClientCoinGecko.get(apiNameCoinGecko.coin_market,{
        params:{
            ...param
        }
    })
}


export const callAPiCoinTicker = (param={},id=0) => {
    return apiClientCoinGecko.get(`/coins/${id}/tickers`,{
        params:{
            ...param,
            "depth":true,
            "include_exchange_logo":true
        }
    })
}

export const callApiExchangeRates = (parram={}) =>{
    return apiClientCoinGecko.get(apiNameCoinGecko.exchange_rates,{
        params:{
            ...parram
        }
    });
}


export const callApiExchanges = (parram={}) =>{
    return apiClientCoinGecko.get(apiNameCoinGecko.exchanges,{
        params:{
            ...parram
        }
    });
}

export const callApiCategories = (parram={}) =>{
    return apiClientCoinGecko.get(apiNameCoinGecko.categories,{
        params:{
            ...parram
        }
    });
}

export const callApiSearchTrending = (parram={}) =>{
    return apiClientCoinGecko.get(apiNameCoinGecko.search_trending,{
        params:{
            ...parram
        }
    });
}